<template>
  <expandable-container :height="'1rem'">
    <div v-for="(translation, lang) in value" :key="lang" class="d-flex align-items-center">
      <locale-flag :locale="getLocale(lang)"></locale-flag>
      <span class="ps-2">{{ translation }}</span>
    </div>
  </expandable-container>
</template>

<script>
import ExpandableContainer from '@kanrisha/components/Elements/Container/ExpandableContainer';
import LocaleFlag from '@kanrisha/components/Misc/LocaleFlag';
import useLocale from '@kanrisha/composables/useLocale';

export default {
  components: {
    ExpandableContainer,
    LocaleFlag,
  },
  props: {
    value: { type: Object, default: () => ({ de: '<fehlt>', en: '<missing>' }) },
  },
  setup() {
    const { getLocale } = useLocale();

    return {
      getLocale,
    };
  },
};
</script>
